module.exports = __webpack_public_path__ + "static/media/bridge.edd5a91e.png";